import Api from "../../lib/api";

export const ACTIVITY_DETAILS = {
  start: "fetch_start/activity_details",
  end: "fetch_end/activity_details",
  success: "fetch_success/activity_details",
  failed: "fetch_failed/activity_details",
};

export const activityDetailsFetchStart = () => ({
  type: ACTIVITY_DETAILS.start,
});

export const activityDetailsFetchEnd = () => ({
  type: ACTIVITY_DETAILS.end,
});

export const activityDetailsFetchSuccess = (data) => ({
  type: ACTIVITY_DETAILS.success,
  data,
});

export const activityDetailsFetchFailed = (error) => ({
  type: ACTIVITY_DETAILS.failed,
  error,
});

export const updateActivityDetails = (identifier) => (dispatch) => {
  dispatch(activityDetailsFetchStart());
  if (identifier !== null) {
    return Api.get(Api.API_ACTIVITY_DETAILS(identifier))
      .then((response) => {
        dispatch(activityDetailsFetchEnd());
        dispatch(activityDetailsFetchSuccess(response.data));
      })
      .catch((exception) => {
        dispatch(activityDetailsFetchEnd());
        dispatch(activityDetailsFetchFailed(exception));
      });
  }
};



// WEBPACK FOOTER //
// ./shared/actions/getActivityDetails.js